export default [
  '#007aff',
  '#ff3b30',
  '#4cd964',
  '#2196f3',
  '#ff2d55',
  '#ffcc00',
  '#ff9500',
  '#9c27b0',
  '#673ab7',
  '#5ac8fa',
  '#009688',
  '#cddc39',
  '#ff6b22',
  '#8e8e93'
]
